import React from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { PROJECTS_ROUTE } from "../routes/routes";
import RelatedList from "../utils/RelatedList";

import type { JSX } from "react";

import type { IAdvertisingSingle } from "../../types";

interface Props {
  advertisingCampaign: IAdvertisingSingle;
}

function AdvertisingOfferPlanList({ advertisingCampaign }: Props): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-advertisings");

  const formatedOffers = advertisingCampaign.offers?.map((offer) => ({
    label: offer.label,
    uuid: offer.uuid,
    url: `${PROJECTS_ROUTE}/${projectSlug}/offers/edit/${offer.uuid}`,
  }));

  return (
    <div className="editor-form-section gap-[0.46875rem] pt-[1.5625rem]!">
      <div className="editor-form-section-title">{t("relatedOffers")}</div>
      {advertisingCampaign.offers?.length > 0 ? (
        <RelatedList items={formatedOffers} />
      ) : (
        <div>{t("noRelatedOffers")}</div>
      )}
    </div>
  );
}

export default AdvertisingOfferPlanList;
